import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { Toast } from 'src/app/shared/models/signature.model';

declare var $:any;

@Injectable({
  providedIn: 'root'
})
export class ToastBehaviorService {

  private toastSource = new BehaviorSubject<Toast>({'title':'', 'body':'', 'valid':'bg-success'});

  get = this.toastSource.asObservable();

  constructor() { }

  set(title:string, body:string, valid:string){
    this.toastSource.next({'title': title, 'body': body, 'valid': valid});
    $('.toast').toast('show')
  }
}
